<template>
  <div class="box">
    <el-row
      ><h3 style="margin-top: 0px">{{ $route.query.title }}</h3></el-row
    >
    新闻标题：<el-input v-model="title" placeholder="请输入新闻标题"></el-input><br /><br />
    发布日期：<el-date-picker format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd" v-model="releaseTime" placeholder="请选择新闻发布日期"></el-date-picker><br /><br />
    新闻内容：<quill-editor ref="text" v-model="content" class="myQuillEditor" :options="editorOption" @change="onEditorChange($event)" />
    <input type="file" accept=".webp,.png,.jpg,.jpeg" @change="changePic" multiple id="quillPicUpload"
                         style="display: none" />
    <input type="file" accept="video/*" @change="changeVideo" id="quillVideoUpload" style="display: none" />
    <input type="file" @change="changeFile" id="quillFileUpload" style="display: none" />
    <el-row style="margin-top:50px;">
      <el-button type="success" @click="submit">发布</el-button>
    </el-row>
  </div>
</template>
<script>
// import axios from 'axios'
import { add, fileUpload, login } from '../../api/api'
import global from '@/utils/global.js'
import axios from 'axios'
import { quillEditor, Quill } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { container, ImageExtend, QuillWatch } from 'quill-image-extend-module'
import { ImageDrop } from 'quill-image-drop-module'
import ImageResize from 'quill-image-resize-module'
Quill.register('modules/imageDrop', ImageDrop)
Quill.register('modules/imageResize', ImageResize)
Quill.register('modules/ImageExtend', ImageExtend)
// axios.defaults.withCredentials = true

export default {
  components: { quillEditor },
  data() {
    return {
      title: '', // 标题内容
      releaseTime: '', // 发布日期
      content: '', // 新闻内容
      picture: null,
      photo: '',
      newsCategoryId: 34,
      picturePath: null,
      editorOption: {
        placeholder: '请输入正文',
        modules: {
          imageDrop: true,
          imageResize: {
              handleStyles: {
                displaySize: true,
                backgroundColor: "black",
                border: "none",
                color: "white",
              },
              modules: ["Resize", "DisplaySize"],
          },
          clipboard: {
            matchers: [[Node.ELEMENT_NODE, this.stopImgClip]],
          },
          toolbar: {
            container: [
                ['bold', 'italic', 'underline', 'strike'], // 加粗 斜体 下划线 删除线 -----['bold', 'italic', 'underline', 'strike']
                ['blockquote', 'code-block'], // 引用  代码块-----['blockquote', 'code-block']
                [{ header: 1 }, { header: 2 }], // 1、2 级标题-----[{ header: 1 }, { header: 2 }]
                [{ list: 'ordered' }, { list: 'bullet' }], // 有序、无序列表-----[{ list: 'ordered' }, { list: 'bullet' }]
                [{ script: 'sub' }, { script: 'super' }], // 上标/下标-----[{ script: 'sub' }, { script: 'super' }]
                [{ indent: '-1' }, { indent: '+1' }], // 缩进-----[{ indent: '-1' }, { indent: '+1' }]
                [{ direction: 'rtl' }], // 文本方向-----[{'direction': 'rtl'}]
                [{ size: ['12px', '100%', '16px', '18px', '20px', '22px', '24px', '28px', '32px', '48px'] }], // 字体大小-----[{ size: ['small', false, 'large', 'huge'] }]
                [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题-----[{ header: [1, 2, 3, 4, 5, 6, false] }]
                [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色-----[{ color: [] }, { background: [] }]
                [{ font: [] }], // 字体种类-----[{ font: [] }]
                [{ align: [] }], // 对齐方式-----[{ align: [] }]
                ['clean'], // 清除文本格式-----['clean']
                ['image'] // 链接、图片、视频-----['link', 'image', 'video']
            ],
            handlers: {
                image: function (value) {
                    if (value) {
                        document.querySelector('#quillPicUpload').click() // 劫持原来的图片点击按钮事件
                    } else {
                        this.quill.format('image', false)
                    }
                },
                video: function (value) {
                    if (value) {
                        document.querySelector('#quillVideoUpload').click()
                    } else {
                        // return
                        this.quill.format('video', false)
                    }
                },
                // 文件上传
                upload: value => {
                    if (value) {
                        document.querySelector('#quillFileUpload').click()
                    } else {
                        this.quill.format('upload', false)
                    }
                }
            }
          }
        }
      }, // 编辑器新闻对象
      fileList: []
    }
  },
  created() {
    // console.log('>>>>>>>',this.$route.query.id);
    this.newsCategoryId = this.$route.query.id
  },
  mounted() {},
  methods: {
    // 图片上传
    changePic(e) {
        let fileList = e.target.files
        let formData = new FormData()
        for (let i = 0; i < fileList.length; i++) {
            formData.append('file', fileList[i])
        }
        axios
            .post(global.baseURL + 'uploading', formData)
            .then(res => {
                //console.log(res.data.update_image)
                if (res.data.code == 200) {
                    let picList = global.fileServer + "file/getFile?fileName=" + res.data.data
                    if (this.picturePath == null || this.picturePath == undefined) {
                      this.picturePath = res.data.data
                    }
                    let quill = this.$refs.text.quill

                    let range = quill.getSelection();
                    let index = range.index; // 光标位置
                    //console.log("picList", picList)
                    quill.insertEmbed(index, 'image', picList) // 插入图片  图片地址
                    // 调整光标到最后
                    quill.setSelection(index + 1) // 光标后移一位
                } else {
                    this.$message({
                        message: '图片上传失败：',
                        type: 'error'
                    })
                }
            })
            .catch(err => {
                console.log(err)
            })
    },
    // 上传视频
    changeVideo(e) {
        this.$message.warning('不支持上传视频')
    },
    // 上传文件
    changeFile(e) { },
    stopImgClip(node, Delta) {
        let ops = []
        Delta.ops.forEach(op => {
            //console.log("op insert:", op.insert)
            if (op.insert && typeof op.insert === 'string') {
                ops.push({
                    insert: op.insert,
                })
            } else { //给出提醒
                if (op.insert.image) {
                    if (!op.insert.image.includes("base64")) {
                      this.$message({
                        message: '图片格式不正确',
                        type: 'error',
                      });
                      return;
                    }
                    //给个提示
                    this.$message({
                        message: '粘贴的内容是图片',
                        type: 'warning',

                    })
                    //调用方法
                    this.mybase64tofileandupload(op.insert.image)
                }
            }
        })
        Delta.ops = ops
        //console.log("ops", ops);
        return Delta
    },
    mybase64tofileandupload(image) {
      //console.log("image base64", image);
      let formData = new FormData()
      formData.append('image', image)

      // 上传base64图片
      axios.post(global.baseURL + "/saveImage", formData)
              .then(res => {
                //console.log("mybase64tofileandupload", res.data)
                if (res.data.code == 200) {
                    let picList = global.fileServer + "file/getFile?fileName=" + res.data.data
                    if (this.picturePath == null || this.picturePath == undefined) {
                      this.picturePath = res.data.data
                    }
                    let quill = this.$refs.text.quill

                    let range = quill.getSelection();
                    let index = range.index; // 光标位置
                    //console.log("picList", picList)
                    quill.insertEmbed(index, 'image', picList) // 插入图片  图片地址
                    // 调整光标到最后
                    quill.setSelection(index + 1) // 光标后移一位
                } else {
                    this.$message({
                        message: '图片上传失败：',
                        type: 'error'
                    })
                }
            })
            .catch(err => {
                console.log(err)
            })
    },
    onEditorChange(event) {
      //this.$emit('getEditorInfo', event)
    },
    submit() {
      const data = {
        newsCategoryId: this.newsCategoryId,
        content: this.content,
        title: this.title,
        releaseTime: this.releaseTime,
        picturePath: this.picturePath
      }
      console.log(this.content)
      // console.log(this.newsCategoryId);
      add(data).then(res => {
        console.log(res)
        if (res.code !== 200) {
          return this.$message.error('发布新闻失败，请重试！')
        } else {
          this.$message.success('新闻发布成功！')
          console.log(this.content)
          this.$router.go(-1)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.box {
  width: 1200px;
  margin: 0 auto;
}
.myQuillEditor {
  height: 350px;
}
.btn {
  position: absolute;
  bottom: 20px;
  left: 168px;
}
</style>
